import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProjects,
  selectDashboardSelectedProject,
} from "../../state/workspaces/projects.selector";
import {
  queueProjectLoading,
  selectProject,
} from "../../state/workspaces/workspaces.actions";
import { getWaitingToLoadProjectID } from "../../state/workspaces/workspaces.selector";
import { Localized } from "../../strings";
import Styles from "./ProjectNavigationInformation.module.css";

export const ProjectNavigationInformation = () => {
  const waitingProjectId = useSelector(getWaitingToLoadProjectID);
  const allProjects = useSelector(getAllProjects);
  const selectedProject = useSelector(selectDashboardSelectedProject);
  const dispatch = useDispatch();
  const [noAccessToProject, setNoAccessToProject] = useState(false);
  const strings = Localized.object("HEADER");

  useEffect(() => {
    if (!waitingProjectId || !allProjects) return;

    const project = allProjects?.find(
      (project) => project.id === waitingProjectId,
    );

    if (project) {
      setNoAccessToProject(false);
      dispatch(queueProjectLoading(undefined));
      dispatch(selectProject(project));
    } else if (allProjects && waitingProjectId) {
      dispatch(queueProjectLoading(undefined));
      setNoAccessToProject(true);

      if (selectedProject) {
        dispatch(selectProject(null));
      }
    }
  }, [waitingProjectId, allProjects]);

  useEffect(() => {
    selectedProject && noAccessToProject && setNoAccessToProject(false);
  }, [selectedProject]);

  return (
    <>
      {noAccessToProject && (
        <div className={Styles.projectInformation}>{strings.NO_ACCESS}</div>
      )}
    </>
  );
};
